import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import './assets/css/style-page2.css';
import '../Style/typo.css'
import BgBottom from './assets/image/bg-bottom.png';
import FrameBG from './assets/image/Frame.png';
import Image763 from './assets/image/image 763.png';
import AiImg1 from './assets/image/ai-img1.png';
import AiImg2 from './assets/image/ai-img2.png';
import AiFilled from './assets/image/ai-filled.svg';
import GroupwareCRM from './assets/image/groupware-crm 1.png';
import VectorBan from './assets/image/vector-ban.png';
import VectorLine from './assets/image/Vector 3.png';
import ReturnVisitor from './assets/image/returning_visitor.png';
import { Check } from '@mui/icons-material';
import { ChevronRight } from "@mui/icons-material";
import { ArrowRightAlt } from "@mui/icons-material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import EmailIcon from '@mui/icons-material/Email';
import ForumIcon from '@mui/icons-material/Forum';
import PhoneIcon from '@mui/icons-material/Phone';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DnsIcon from '@mui/icons-material/Dns';
import GroupsIcon from '@mui/icons-material/Groups';
import ApartmentIcon from '@mui/icons-material/Apartment';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.querySelector(location.hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return null;
};

function IndexVietnamese() {
    const [activated, setActivated] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setActivated(false);
                    setTimeout(() => setActivated(true), 200);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const CountUp = ({ start, end, duration, activated }) => {
        const [count, setCount] = useState(start);

        useEffect(() => {
            if (activated) {
                setCount(start);
                let current = start;
                const step = (end - start) / (duration * 60);

                const interval = setInterval(() => {
                    current += step;
                    if (current >= end) {
                        setCount(end);
                        clearInterval(interval);
                    } else {
                        setCount(Math.ceil(current));
                    }
                }, 1000 / 60);

                return () => clearInterval(interval);
            }
        }, [activated, start, end, duration]);

        return <span>{count.toLocaleString()}</span>;
    };


    useEffect(() => {
        const featureBoxes = document.querySelectorAll(".feature-box-col");

        featureBoxes.forEach((featureBox) => {
            const slideContainer = featureBox.querySelector(".slides");
            const dotsContainer = featureBox.querySelector(".dots");
            if (!slideContainer || !dotsContainer) return;

            const totalSlides = slideContainer.querySelectorAll("img").length;
            let currentIndex = 0;

            dotsContainer.innerHTML = "";

            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement("div");
                dot.classList.add("dot");
                if (i === 0) dot.classList.add("active");
                dotsContainer.appendChild(dot);

                dot.addEventListener("click", () => {
                    currentIndex = i;
                    updateSlidePosition();
                    updateDots();
                });
            }

            const dots = dotsContainer.querySelectorAll(".dot");

            const updateSlidePosition = () => {
                const slideWidth = slideContainer.clientWidth;
                slideContainer.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
            };

            const updateDots = () => {
                dots.forEach((dot, index) => {
                    dot.classList.toggle("active", index === currentIndex);
                });
            };

            const autoSlide = () => {
                currentIndex = (currentIndex + 1) % totalSlides;
                updateSlidePosition();
                updateDots();
            };

            const interval = setInterval(autoSlide, 3000);

            const tabButtons = document.querySelectorAll('[data-bs-toggle="pill"]');
            tabButtons.forEach((tab) => {
                tab.addEventListener("click", () => {
                    currentIndex = 0;
                    updateSlidePosition();
                    updateDots();
                });
            });

            return () => clearInterval(interval);
        });
    }, []);


    // const scrollRef = useRef(null);

    // useEffect(() => {
    //     const scrollContainer = scrollRef.current;
    //     const imgElements = scrollContainer.querySelectorAll("img");

    //     // Duplicate nội dung để tạo hiệu ứng lặp
    //     scrollContainer.innerHTML += scrollContainer.innerHTML;

    //     const totalImages = imgElements.length;
    //     const imgWidth = imgElements[0].offsetWidth + 40; // 40 là margin/padding
    //     const totalWidth = totalImages * imgWidth;

    //     const duration = totalWidth / 30;

    //     scrollContainer.style.animationDuration = `${duration}s`;
    // }, []);

    return (

        <div className="indexpage2">
            <NavButton option={{
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061FF' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            <ScrollToSection />
            <div className="header-ban">
                <div className="fit-box p-r-l">
                    <FadeInSection>
                        <div className="header-ban-tt">
                            <div className="header-ban-tt-left">
                                <p className="txt-48 wh-color mb-4">Xây dựng và vận hành <br />
                                hệ thống IT toàn diện</p>
                                <p className="txt-21 wh-color">Chúng tôi mang đến giải pháp IT tối ưu hóa theo nhu cầu, dựa trên nền tảng đám mây linh hoạt, giúp doanh nghiệp xử lý trọn gói từ hạ tầng, phần mềm, phần cứng đến tích hợp AI cộng tác</p>
                            </div>
                            <div className="header-ban-tt-right">
                                <Link to="#ai-feature2" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">Giải pháp Groupware tích hợp AI</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">Quản lý & vận hành Cloud/Server</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">Giải pháp hạ tầng Kubernetes riêng</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">Xây dựng hạ tầng LLM tùy chỉnh</div>
                                </Link>
                                <Link to="#ai-feature4" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ArrowCircleDownIcon className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">Cung cấp API Microservices Cloud</div>
                                </Link>
                            </div>
                        </div>
                    </FadeInSection>


                </div>
            </div>

            <div className="wrap-box ai-LLM" id="ai-LLM">
                <FadeInSection>
                    <div className="fit-box">
                        <div className="wrap-title">
                            <p className="typo-32-mb">Giải pháp Groupware tích hợp trí tuệ nhân tạo</p>
                            <p className="typo-21">AI & LLM doanh nghiệp • Vận hành server / Cam kết bảo vệ dữ liệu khách hàng</p>
                        </div>

                        <div className="feature-dt">
                            <div className="fea-dt">
                                <div className="fea-dt-box">
                                    <div className="fea-dt-col left">
                                        <div className="fea-dt-row">
                                            <div className="fea-dt-item">
                                                <EmailIcon className="fea-icon" />
                                                <div>
                                                    <p className="typo-21-sm typo-medium">Email</p>
                                                    <p className="typo-14">Tóm tắt · Dịch thuật · Gợi ý nội dung email</p>
                                                </div>
                                            </div>
                                            <div className="fea-dt-item">
                                                <ForumIcon className="fea-icon" />
                                                <div>
                                                    <p className="typo-21-sm typo-medium">Messenger</p>
                                                    <div>
                                                        <p className="typo-14">Dịch tự động·Gửi tin nhắn</p>
                                                        <p className="typo-14">Tóm tắt · Dịch hội thoạt</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="fea-dt-item">
                                                <PhoneIcon className="fea-icon" />
                                                <div>
                                                    <p className="typo-21-sm typo-medium">AI Call +</p>
                                                    <p className="typo-14">Tách giọng nói · Tóm tắt · Dịch thuật</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="fea-dt-row">
                                            <div className="fea-dt-item">
                                                <RequestPageIcon className="fea-icon" />
                                                <div>
                                                    <p className="typo-21-sm typo-medium">Phê duyệt</p>
                                                    <p className="typo-14">Tóm tắt · Dịch thuật · Soạn thảo sơ bộ</p>
                                                </div>
                                            </div>
                                            <div className="fea-dt-item">
                                                <ConfirmationNumberIcon className="fea-icon" />
                                                <div>
                                                    <p className="typo-21-sm typo-medium">Helpdesk</p>
                                                    <p className="typo-14">Tóm tắt ·Dịch thuật</p>
                                                </div>
                                            </div>
                                            <div className="fea-dt-item">
                                                <FactCheckIcon className="fea-icon" />
                                                <div>
                                                    <p className="typo-21-sm typo-medium">Nhật ký công việc</p>
                                                    <p className="typo-14">Tóm tắt · Dịch thuật</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>

            </div>

            <div className="wrap-box ai-feature2" id="ai-feature2">
                <FadeInSection>
                    <div className="fit-box">
                        <div>
                            <div className="wrap-title">
                                <p className="typo-32">Groupware</p>
                            </div>

                            <div className="ai-feature2-ct">
                                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link typo-medium active" id="pills-fea1-tab" data-bs-toggle="pill" data-bs-target="#pills-fea1" type="button" role="tab" aria-controls="pills-fea1" aria-selected="true">Email</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link typo-medium" id="pills-fea2-tab" data-bs-toggle="pill" data-bs-target="#pills-fea2" type="button" role="tab" aria-controls="pills-fea2" aria-selected="false">Messenger</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link typo-medium" id="pills-fea3-tab" data-bs-toggle="pill" data-bs-target="#pills-fea3" type="button" role="tab" aria-controls="pills-fea3" aria-selected="false">Helpdesk</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link typo-medium" id="pills-fea4-tab" data-bs-toggle="pill" data-bs-target="#pills-fea4" type="button" role="tab" aria-controls="pills-fea4" aria-selected="false">Phê duyệt</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link typo-medium" id="pills-fea5-tab" data-bs-toggle="pill" data-bs-target="#pills-fea5" type="button" role="tab" aria-controls="pills-fea5" aria-selected="false">Nhân sự</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link typo-medium" id="pills-fea6-tab" data-bs-toggle="pill" data-bs-target="#pills-fea6" type="button" role="tab" aria-controls="pills-fea6" aria-selected="false">Quản lý dự án</button>
                                    </li>

                                </ul>
                                <div className="gw-menu-block gw-menu-block-tab">
                                    <div className="menu-line">
                                        <p className="gw-menu-item typo-14">Lịch</p>
                                        <p className="gw-menu-item typo-14">Danh bạ</p>
                                        <p className="gw-menu-item typo-14">Bảng tin</p>
                                        <p className="gw-menu-item typo-14">Ghi chú</p>
                                        <p className="gw-menu-item typo-14">Clouddisk</p>
                                        <p className="gw-menu-item typo-14">Công văn</p>
                                        <p className="gw-menu-item typo-14">Todo</p>
                                        <p className="gw-menu-item typo-14">Lưu trữ</p>
                                        <p className="gw-menu-item typo-14">Tài sản</p>
                                        <p className="gw-menu-item typo-14">Báo cáo chi phí</p>
                                        {/* <p className="gw-menu-item typo-14">다국어지원</p> */}
                                    </div>
                                </div>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane show active" id="pills-fea1" role="tabpanel" aria-labelledby="pills-fea1-tab">
                                        <div className="feature-box">
                                            <div className="feature-box-col">
                                                <p className="typo-21 typo-medium">Lọc Email & Thư rác</p>
                                                <div className="sub-tt">
                                                    <p className="typo-14 txt-color">Cung cấp chức năng dịch thuật và tóm tắt dựa trên AI</p>
                                                    <p className="typo-14 txt-color">Bộ lọc thư rác được tích hợp sẵn trong hệ thống Groupware</p>
                                                </div>

                                                <div className="feature-box-text">
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">SPF, DKIM, DMARC</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Hỗ trợ POP3/IMAP, chặn đến 95% thư rác</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Email bảo mật, Email phê duyệt, Email hàng loạt</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Tích hợp email bên ngoài, chia sẻ hộp thư (bao gồm nhân viên đã nghỉ)</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Chia sẻ và chuyển tiếp email của nhân viên đã nghỉ</p>
                                                    </div>
                                                </div>

                                                <div className="feature-btn-gr">
                                                    <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/mail-free-trial.html?SM=SPCMLKO">Đăng ký dùng thử</a></button>
                                                    {/* <button className="fea-button secondary-btn typo-14">View more</button> */}
                                                </div>
                                            </div>
                                            <div className="feature-box-col">
                                                <div className="feature-box-img feature-shadow">
                                                    <div className="slides">
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 3" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                    </div>
                                                </div>
                                                <div className="dots"></div>
                                            </div>
                                            {/* <div className="feature-box-col">
                                        <div className="feature-box-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/1.gif" />
                                        </div>
                                    </div> */}
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="pills-fea2" role="tabpanel" aria-labelledby="pills-fea2-tab">
                                        <div className="feature-box">
                                            <div className="feature-box-col">
                                                <p className="typo-21 typo-medium mb-2">Trò chuyện & Cuộc họp trực tuyến</p>
                                                <div className="sub-tt">
                                                    <p className="typo-14 txt-color">Giao tiếp thời gian thực linh hoạt với các thành viên trong nhóm.</p>
                                                </div>

                                                <div className="feature-box-text">
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Tóm tắt và dịch nội dung cuộc họp trực tuyến</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Dịch hội thoại trực tiếp • Tóm tắt cuộc trò chuyện trong ngày</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Hỗ trợ cộng tác công việc qua chia sẻ màn hình, gọi thoại và họp trực tuyến</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Cho phép mời khách tham gia cuộc họp trực tuyến.</p>
                                                    </div>
                                                </div>

                                                <div className="feature-btn-gr">
                                                    <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/messenger-free-trial.html?SM=SPCMM">데모 신청</a></button>
                                                    {/* <button className="fea-button secondary-btn typo-14">View more</button> */}
                                                </div>
                                            </div>
                                            <div className="feature-box-col">
                                                <div className="feature-box-img feature-shadow">
                                                    <div className="slides">
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 3" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                    </div>

                                                </div>
                                                <div className="dots"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="pills-fea3" role="tabpanel" aria-labelledby="pills-fea3-tab">
                                        <div className="feature-box">
                                            <div className="feature-box-col">
                                                <div className="fea-sub-tt">
                                                    <p className="typo-21 typo-medium mb-2">Ticket</p>
                                                    <div>
                                                        <p className="typo-14 txt-color">Tổng hợp và quản lý mọi yêu cầu khách hàng trên một nền tảng duy nhất.</p>
                                                        <p className="typo-14 txt-color">Theo dõi và hỗ trợ toàn bộ quy trình từ lúc tiếp nhận đến khi phản hồi cuối cùng được gửi đi.</p>
                                                    </div>
                                                </div>

                                                <div>
                                                    <p className="typo-21 typo-medium mb-2">AI call +</p>
                                                    <div>
                                                        <p className="typo-14 txt-color">Lưu trữ và phân tích lịch sử cuộc gọi với khách hàng.</p>
                                                        <p className="typo-14 txt-color">Nâng cao chất lượng dịch vụ dựa trên thông tin cuộc gọi và dữ liệu liên quan.</p>
                                                        <p className="typo-14 txt-color">Tóm tắt và dịch nội dung cuộc gọi bằng AI.</p>
                                                    </div>
                                                </div>

                                                <div className="feature-btn-gr">
                                                    <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">데모 신청</a></button>
                                                    {/* <button className="fea-button secondary-btn typo-14">View more</button> */}
                                                </div>
                                            </div>
                                            <div className="feature-box-col">
                                                <div className="feature-box-img feature-shadow">
                                                    <div className="slides">
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 3" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                    </div>

                                                </div>
                                                <div className="dots"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="pills-fea4" role="tabpanel" aria-labelledby="pills-fea4-tab">
                                        <div className="feature-box">
                                            <div className="feature-box-col">
                                                <p className="typo-21 typo-medium mb-2">Phê duyệt</p>
                                                <div className="sub-tt">
                                                    <p className="typo-14 txt-color">Thực hiện quy trình phê duyệt mọi lúc, 
                                                        mọi nơi qua PC hoặc thiết bị di động, giúp xử lý công việc nhanh chóng và hiệu quả.</p>
                                                </div>

                                                <div className="feature-box-text">
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Cung cấp miễn phí khoảng 300 biểu mẫu cơ bản</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Hỗ trợ công thức tự động và tính toán đơn giản với Excel editor</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Tăng cường bảo mật với quy trình phê duyệt hai lớp</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Thiết lập và lưu phê duyệt riêng cho từng biểu mẫu</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Liên kết hệ thống ERP, SAP và các hệ thống quản lý nội bộ khác</p>
                                                    </div>
                                                </div>

                                                <div className="feature-btn-gr">
                                                    <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">데모 신청</a></button>
                                                    {/* <button className="fea-button secondary-btn typo-14">View more</button> */}
                                                </div>
                                            </div>
                                            <div className="feature-box-col">
                                                <div className="feature-box-img feature-shadow">
                                                    <div className="slides">
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 3" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                    </div>

                                                </div>
                                                <div className="dots"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="pills-fea5" role="tabpanel" aria-labelledby="pills-fea5-tab">
                                        <div className="feature-box">
                                            <div className="feature-box-col">
                                                <p className="typo-21 typo-medium mb-2">Quản lý chấm công & nghỉ phép</p>
                                                <div className="sub-tt">
                                                    <p className="typo-14 txt-color">Hỗ trợ đa dạng hình thức làm việc: cố định, linh hoạt,... Tự động hóa việc quản lý ngày nghỉ giúp kiểm soát giờ ra/vào và ngày nghỉ của nhân viên.</p>
                                                </div>

                                                <div className="feature-box-text">
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Chấm công qua di động bằng GPS, WiFi hoặc Beacon</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Cung cấp chức năng phê duyệt chấm công</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Xuất báo cáo theo ngày/tuần/tháng dưới dạng Excel</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Theo dõi tình trạng chấm công và nghỉ phép của nhân viên qua Dashboard</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Tự động quản lý ngày phép và hỗ trợ chế độ khuyến khích sử dụng ngày nghỉ</p>
                                                    </div>
                                                </div>

                                                <div className="feature-btn-gr">
                                                    <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/hanbiro-hr-free-trial.html?SM=MOBILEPUNCHIN">데모 신청</a></button>
                                                    {/* <button className="fea-button secondary-btn typo-14">View more</button> */}
                                                </div>
                                            </div>
                                            <div className="feature-box-col">
                                                <div className="feature-box-img feature-shadow">
                                                    <div className="slides">
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 3" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                    </div>

                                                </div>
                                                <div className="dots"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane" id="pills-fea6" role="tabpanel" aria-labelledby="pills-fea6-tab">
                                        <div className="feature-box">
                                            <div className="feature-box-col">
                                                <p className="typo-21 typo-medium mb-2">Quản lý Dự án</p>
                                                <div className="sub-tt">
                                                    <p className="typo-14 txt-color">Tạo mẫu công việc phù hợp với doanh nghiệp, phân công người phụ trách, giúp quản lý tiến độ một cách khoa học và hiệu quả.</p>
                                                </div>

                                                <div className="feature-box-text">
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Tùy chỉnh quy trình làm việc theo đặc thù của từng công ty</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Phân công rõ ràng, tránh chồng chéo và đảm bảo công việc diễn ra trôi chảy</p>
                                                    </div>
                                                    <div className="block-li">
                                                        <Check className="check" />
                                                        <p className="typo-14 txt-color">Cập nhật thay đổi tức thì, giúp nắm bắt tiến độ công việc theo thời gian thực</p>
                                                    </div>
                                                </div>

                                                <div className="feature-btn-gr">
                                                    <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">데모 신청</a></button>
                                                    {/* <button className="fea-button secondary-btn typo-14">View more</button> */}
                                                </div>
                                            </div>
                                            <div className="feature-box-col">
                                                <div className="feature-box-img feature-shadow">
                                                    <div className="slides">
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-summary-1-sm.png" alt="Slide 1" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/mail-spam-1-sm.png" alt="Slide 2" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/ai-call-1-sm.png" alt="Slide 3" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/project-1-sm.png" alt="Slide 4" />
                                                        <img src="https://hanbiro.com/assets/images/cloud/task-summary-1-sm.png" alt="Slide 5" />
                                                    </div>

                                                </div>
                                                <div className="dots"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="menu-block">
                                        <div className="menu-line">
                                            <p className="menu-item typo-14"><b>Hỗ trợ đa ngôn ngữ</b></p>
                                            <p className="menu-item typo-14"><b>Tích hợp ERP - SAP</b></p>
                                            {/* <div className="menu-item typo-14"><b>프라이빗 LLM 서버 - AI 통합</b></div> */}
                                            <p className="menu-item typo-14"><b>iOS</b></p>
                                            <p className="menu-item typo-14"><b>Tích hợp AI</b></p>
                                            <p className="menu-item typo-14"><b>Android</b></p>
                                            <p className="menu-item typo-14"><b>Linux</b></p>
                                            <p className="menu-item typo-14"><b>Mobile - Tablet</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>

            </div>

            <div className="wrap-box ai-feature4" id="ai-feature4">
                <div className="fit-box">
                    <div className="wrap-title">
                        <p className="typo-32">Private Cloud</p>
                        {/* <div className="txt-21-thin">기업
                            전용 AI · LLM
                            서버운영     고객의 데이터 학습제외 · 고객데이터보호</div> */}
                    </div>

                    <div className="ai-feature4-ct">
                        <div className="feature-box">
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">Xây dựng & vận hành hạ tầng Kubernetes riêng</p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Tối ưu  hóa vận hành máy chủ, tự động gia tăng và mở rộng tài nguyên</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Tự động phục hồi hệ thống khi xảy ra sự cố, hỗ trợ auto-scaling, luôn đảm bảo tính ổn định của dịch vụ</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Tối ưu vận hành ứng dụng theo kiến trúc Microservices</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Xây dựng hạ tầng cụm (cluster) riêng dành cho từng khách hàng, tăng cường bảo mật</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Hỗ trợ di chuyển ứng dụng từ môi trường bare metal</p>
                                    </div>
                                </div>

                            </div>
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">Dịch vụ quản lý & vận hành máy chủ Cloud</p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Hỗ trợ cho hệ điều hành Linux và Windows</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Khởi tạo tài nguyên máy chủ tối ưu theo từng dịch vụ cụ thể</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Giám sát hệ thống 24/7 bằng phần mềm chuyên dụng</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Đội ngũ kỹ sư giàu kinh nghiệm hỗ trợ quản lý – vận hành liên tục</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Kinh nghiệm quản lý 5.000 máy chủ cho hơn 8.000 đối tác doanh nghiệp</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="feature-box">
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">Triển khai hạ tầng máy chủ ảo & LLM riêng</p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Triển khai môi trường máy chủ ảo hiện đại với nền tảng Proxmox VE</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Máy chủ ảo hoạt động liên tục – không gián đoạn, không downtime</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Xây dựng và vận hành hạ tầng LLM cá nhân hóa theo nhu cầu doanh nghiệp</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Tích hợp và phát triển hệ thống RAG dựa trên LLM - tối ưu cho dữ liệu nội bộ</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Hạ tầng AI riêng biệt, đảm bảo bảo mật tuyệt đối cho mọi thông tin doanh nghiệp</p>
                                    </div>
                                </div>

                            </div>
                            <div className="feature-box-col">
                                <p className="typo-21 typo-medium kuber-title" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">API Microservices dựa trên nền tảng Cloud</p>
                                <div className="feature-box-text">
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Xây dựng kiến trúc phân tán & serverless dựa trên event sourcing</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Bảo mật truy cập toàn diện với IAM, OAuth và phân quyền chi tiết theo vai trò</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Hỗ trợ chức năng tự động hóa theo sự kiện: Messaging, Webhook, Scheduler</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Cung cấp dịch vụ như lưu trữ đối tượng (Object Storage), gửi Email, rút gọn URL</p>
                                    </div>
                                    <div className="block-li">
                                        <KeyboardDoubleArrowRightIcon className="db-arrow" />
                                        <p className="typo-14">Tối ưu hóa quy trình thông qua tự động hóa dựa trên Workflow và Rule</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="feature-btn-gr fill-btn">
                        <button className="fea-button primary-btn typo-14 btn-center"><a className="url-btn" href="https://www.hanbiro.com/application/index.html?Manage=mt1">Đăng ký dịch vụ</a></button>
                    </div>
                </div>
            </div>

            <div className="wrap-box clients" id="clients">
                <div className="fit-box">
                    <div className="stats-section" ref={sectionRef}>
                        <div className="stats-row">
                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">NĂM</p>
                                        <p className="stats-dt typo-14">Kinh nghiệm hoạt động</p>
                                    </div>

                                    <div className="stats-icon">
                                        <CalendarMonthIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={24} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> năm</span>
                                    </p>
                                </div>
                            </div>

                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">SERVERS</p>
                                        <p className="stats-dt typo-14">Quản lý và vận hành server</p>
                                    </div>
                                    <div className="stats-icon">
                                        <DnsIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={5000} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> máy</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="stats-row">
                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">NGƯỜI DÙNG</p>
                                        <p className="stats-dt typo-14">Dịch vụ Email / Groupware</p>
                                    </div>
                                    <div className="stats-icon">
                                        <GroupsIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={300000} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> người dùng</span>
                                    </p>
                                </div>
                            </div>

                            <div className="stats-card">
                                <div className="stats-des">
                                    <div className="stats-content">
                                        <p className="stats-tt typo-21-sm typo-medium">DOANH NGHIỆP</p>
                                        <p className="stats-dt typo-14">Groupware • Quản lý server</p>
                                    </div>
                                    <div className="stats-icon">
                                        <ApartmentIcon className="stats-fea-icon" />
                                    </div>
                                </div>
                                <div className="stats-value">
                                    <p className="typo-32 purple-primary">
                                        <CountUp start={0} end={8000} duration={2} activated={activated} />
                                        <span className="typo-14 typo-black"> công ty</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="wrap-title">
                        <div className="txt-32">한비로와 함께하는 다양한 고객사</div>
                        <div className="txt-32">한비로와 함께 성공적인 길로 나아가는 기업들입니다.</div>
                    </div> */}
                </div>


            </div>

            <div className="wrap-box p-t-0">
                <div className="fit-box">
                    <div className="bg-bottom">
                        <div className="bg-bottom-left">
                            <p className="typo-32-mb typo-white">Làm việc thông minh hơn – Tăng trưởng nhanh hơn</p>
                            <p className="typo-14 typo-white">Tối ưu thời gian với Groupware, giúp đội ngũ tập trung làm việc hiệu quả. Nhận ngay tư vấn để tìm ra giải pháp phù hợp với doanh nghiệp của bạn.</p>
                        </div>
                        <div className="bg-bottom-right">
                            <div className="feature-btn-gr">
                                <button className="fea-button primary-btn typo-14"><a className="url-btn" href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">Đăng ký dùng thử</a></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="newscroll-row">
                    <div className="new-scroll">
                        <div className="new-m-scroll">
                            <img src="https://hanbiro.com/assets/images/cloud/clients/1.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/2.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/3.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/4.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/5.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/6.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/7.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/8.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/9.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/10.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/11.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/12.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/13.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/14.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/15.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/16.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/17.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/18.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/19.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/20.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/21.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/22.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/23.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/24.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/25.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/26.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/27.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/28.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/29.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/30.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/31.png" />
                        </div>
                        {/* <div className="new-m-scroll">
                            <img src="https://hanbiro.com/assets/images/cloud/clients/1.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/2.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/3.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/4.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/5.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/6.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/7.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/8.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/9.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/10.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/11.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/12.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/13.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/14.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/15.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/16.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/17.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/18.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/19.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/20.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/21.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/22.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/23.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/24.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/25.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/26.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/27.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/28.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/29.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/30.png" />
                            <img src="https://hanbiro.com/assets/images/cloud/clients/31.png" />
                        </div> */}
                    </div>
                </div>
            </div>

            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    )
}

export default IndexVietnamese;